import { render, staticRenderFns } from "./info_table.vue?vue&type=template&id=3ba58e31&scoped=true"
import script from "./info_table.vue?vue&type=script&lang=ts"
export * from "./info_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba58e31",
  null
  
)

export default component.exports